var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: {
        appear: "",
        "enter-active-class": "animated fadeIn",
        "leave-active-class": "animated fadeOut"
      }
    },
    [
      _c(
        "q-layout",
        {
          ref: "layout",
          attrs: { view: "hHh LpR fFf" },
          on: { resize: _vm.setLeftVisibility }
        },
        [
          _c(
            "q-layout-header",
            {
              staticStyle: { "box-shadow": "none" },
              attrs: { reveal: "", "reveal-offset": 50 }
            },
            [
              _c(
                "q-toolbar",
                { attrs: { color: "faded" } },
                [
                  _vm.$route.meta.showLeft
                    ? _c("q-btn", {
                        attrs: { flat: "", icon: "menu" },
                        on: {
                          click: function($event) {
                            _vm.leftVisible = !_vm.leftVisible
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("q-btn", {
                    class: { "router-link-active": _vm.menu === "list" },
                    attrs: { flat: "", icon: "fa-building" },
                    on: {
                      click: function($event) {
                        _vm.$router.push("/list")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("q-btn", {
                    class: { "router-link-active": _vm.menu === "cases" },
                    attrs: { flat: "", icon: "fa-briefcase" },
                    on: {
                      click: function($event) {
                        _vm.$router.push("/c")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("q-btn", {
                    class: { "router-link-active": _vm.menu === "search" },
                    attrs: { flat: "", icon: "fa-search" },
                    on: { click: _vm.onSearchClick }
                  }),
                  _vm._v(" "),
                  _vm.$store.state.syncing !== "off"
                    ? _c("q-btn", {
                        class: { "router-link-active": _vm.menu === "medias" },
                        attrs: { flat: "", icon: "fas fa-images" },
                        on: {
                          click: function($event) {
                            _vm.$router.push("/x")
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.wikiEnabled
                    ? _c("q-btn", {
                        class: { "router-link-active": _vm.menu === "wiki" },
                        attrs: { flat: "", icon: "fas fa-book-reader" },
                        on: { click: _vm.goWiki }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("q-toolbar-title"),
                  _vm._v(" "),
                  _vm.$store.state.syncing === "off"
                    ? _c("q-btn", {
                        attrs: { flat: "", color: "warning", icon: "cloud" },
                        on: { click: _vm.goOnline }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "q-btn-dropdown",
                    {
                      class: { "router-link-active": _vm.menu === "profile" },
                      attrs: { flat: "", icon: "fa-id-card" }
                    },
                    [
                      _c(
                        "q-list",
                        { attrs: { link: "" } },
                        [
                          _c(
                            "q-item",
                            {
                              directives: [
                                {
                                  name: "close-overlay",
                                  rawName: "v-close-overlay"
                                }
                              ],
                              nativeOn: {
                                click: function($event) {
                                  _vm.openURL(_vm.$store.state.settings.teamUrl)
                                }
                              }
                            },
                            [
                              _c("q-item-side", {
                                attrs: {
                                  icon: "group",
                                  inverted: "",
                                  color: "secondary"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$store.state.settings.teamName)
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "q-item",
                            {
                              nativeOn: {
                                click: function($event) {
                                  _vm.$router.push("/profile")
                                }
                              }
                            },
                            [
                              _c("q-item-side", {
                                attrs: {
                                  icon: "edit",
                                  inverted: "",
                                  color: "primary"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(_vm._s(_vm.user.screenname))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "q-item",
                            {
                              nativeOn: {
                                click: function($event) {
                                  _vm.$router.push("/sign-in")
                                }
                              }
                            },
                            [
                              _c("q-item-side", {
                                attrs: {
                                  icon: "open_in_new",
                                  inverted: "",
                                  color: "warning"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v("Выйти")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "q-item",
                            {
                              nativeOn: {
                                click: function($event) {
                                  _vm.$router.push("/sign-in?destroy=1")
                                }
                              }
                            },
                            [
                              _c("q-item-side", {
                                attrs: {
                                  icon: "open_in_new",
                                  inverted: "",
                                  color: "negative"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v("Выйти и очистить")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.enableRight
                    ? _c("q-btn", {
                        class: _vm.rightVisible ? "accent" : "",
                        attrs: { flat: "", icon: "fa-bell" },
                        on: {
                          click: function($event) {
                            _vm.rightVisible = !_vm.rightVisible
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "progress", class: _vm.syncingClass },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "progress-track",
                        staticStyle: { width: "100%" }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "progress-model",
                        staticStyle: { width: "0%" }
                      },
                      [_vm._v(" ")]
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-layout-footer",
            {
              staticStyle: { "box-shadow": "none" },
              attrs: { reveal: "", "reveal-offset": 50 }
            },
            [
              _c("q-toolbar", { attrs: { color: "faded" } }, [
                _vm._v("\n        ©alexchetv, 2022\n      ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-page-container",
            [
              _c(
                "transition",
                { attrs: { appear: "", name: _vm.transit, mode: "out-in" } },
                [_c("router-view")],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.enableRight
            ? _c(
                "q-layout-drawer",
                {
                  attrs: { side: "right", breakpoint: _vm.rightBreakpoint },
                  model: {
                    value: _vm.rightVisible,
                    callback: function($$v) {
                      _vm.rightVisible = $$v
                    },
                    expression: "rightVisible"
                  }
                },
                [
                  _c("requests-list", {
                    attrs: {
                      items: _vm.requests,
                      instrumentId: _vm.instrumentId
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.meta.showLeft
            ? _c(
                "q-layout-drawer",
                {
                  ref: "left",
                  attrs: { side: "left" },
                  model: {
                    value: _vm.leftVisible,
                    callback: function($$v) {
                      _vm.leftVisible = $$v
                    },
                    expression: "leftVisible"
                  }
                },
                [_c("router-view", { attrs: { name: "left" } })],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ae020d8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ae020d8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/default.vue
// module id = null
// module chunks = 